import React from 'react'
import Typography from '@material-ui/core/Typography'

import { Box, makeStyles } from '@material-ui/core'
import { AiFillCheckCircle } from 'react-icons/ai'
import { MdCancel } from 'react-icons/md'
import CustomLabel from './CustomLabel'
const useStyles = makeStyles((theme) => ({
  purple: { backgroundColor: '#cc00cc' },
  active: { backgroundColor: '#66cc00' },
  company: { backgroundColor: '#6600cc' },
  hold: { backgroundColor: 'grey' },
  rejected: { backgroundColor: '#ff0000' },
  post: { backgroundColor: 'black' },
}))

export default function Status({ status, label }) {
  const classes = useStyles()

  const statusSwitch = (status) => {
    switch (status) {
      case 'ACTIVE':
        return 'Active'
      case 'LEAVE':
        return 'Leave'
      case 'SUCCESS':
        return 'Won'
      case 'PASS':
        return 'Success'
      case 'Accepted':
        return 'Accepted'
      case 'PARTIAL SUCCESS':
        return 'Partial Won'
      case 'CLOSED':
        return 'Lost'
      case 'SALE':
        return 'Sale'
      case 'Pending':
        return 'Pending'
      case 'SALE RETURN':
        return 'Sale Return'
      case 'Rejected':
        return 'Rejected'
      case 'PRESENT':
        return 'Present'
      case 'ABSENT':
        return 'Absent'
      case 'LATE':
        return 'Late'
      case 'FAIL':
        return 'Failed'
      case 'PUBLISHED':
        return 'Published'
      case 'UNPUBLISHED':
        return 'UnPublished'
      case 'EXPIRED':
        return 'Expired'

      default:
        break
    }
  }

  const statusClassSwitch = (status) => {
    switch (status) {
      case 'ACTIVE':
      case 'LEAVE':
      case 'SUBMIT':
        return classes.purple

      case 'SUCCESS':
      case 'PASS':
        return classes.active
      case 'PRESENT':
      case 'Accepted':
      case 'SALE':
      case 'COMPLETE':
        return classes.active

      case 'Pending':
      case 'PARTIAL SUCCESS':
      case 'LATE':
      case 'EXPIRED':
      case 'PUBLISHED':
      case 'OPEN':
        return classes.hold

      case 'CLOSED':
      case 'SALE RETURN':
      case 'Rejected':
      case 'ABSENT':
      case 'FAIL':
      case 'UNPUBLISHED':
      case 'OVERDUE':
        return classes.rejected

      case 'REOPEN':
        return classes.post

      default:
        break
    }
  }

  return (
    <>
      {label && (
        <Box display="flex" justifyContent="space-evenly">
          {label === 'PRESENT' || label === 'APPROVED' ? (
            <AiFillCheckCircle style={{ color: 'green', fontSize: '20px', cursor: 'pointer' }} />
          ) : (
            <MdCancel style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }} />
          )}

          <CustomLabel label={label} />
        </Box>
      )}
      <Typography
        variant="h6"
        color="initial"
        style={{
          fontSize: '12px',
          padding: '5px 10px',
          borderRadius: '5px',
          color: 'white',
          fontWeight: '600',
          textAlign: 'center',
          // width: '60px',
        }}
        className={statusClassSwitch(status)}
      >
        {/* {statusSwitch(status)} */}
        {status}
      </Typography>
    </>
  )
}
